import React, { useState, useEffect } from "react";
import cx from "classnames";
import Banner from "src/legacy/components/Banner";
import styles from "./streamAccessManagementView.module.scss";
import StreamDefaultIcon from "src/legacy/images/default_stream.png";
import { localizedStrings } from "src/localization/index.jsx";
import _ from "lodash";
import { useDispatch } from "react-redux";
import {
  fetchOwnStreams,
  invalidateStreamAccessUsers,
} from "src/redux/actions/streamAccessController.ts";
import ManageUserAccess from "src/components/managerUserAccess";
import { showSettingsSideMenu } from "src/legacy/redux/actions/settings";
import { useSelector } from "react-redux";
import Tooltip from "src/components/tooltip";
import Text from "src/components/text";

function StreamAccessManagementView(props) {
  const dispatch = useDispatch();

  const [selectedStream, setSelectedStream] = useState({});
  const [hoveredStream, setHoveredStream] = useState("");

  const localizedKeywords = localizedStrings.keywords;
  const localizedCommons = localizedStrings.commons;
  const localizedCommonLoading = localizedCommons.loading;
  const localizatedSettings = localizedStrings.pages.settings;
  const localizedStreamAccess = localizatedSettings.stream_access_management;

  const streams = useSelector((state) =>
    _.get(state, "streamAccessControl.items"),
  );
  const loadingStreams = useSelector((state) =>
    _.get(state, "streamAccessControl.loading"),
  );

  useEffect(() => {
    dispatch(fetchOwnStreams({}));

    return () => {
      onResetClick();
    };
  }, []);

  useEffect(() => {
    if (_.size(selectedStream) == 0 && _.size(streams) > 0) {
      setSelectedStream(streams[0]);
    }
  }, [streams]);

  const onResetClick = () => {
    dispatch(showSettingsSideMenu());
    dispatch(invalidateStreamAccessUsers());
  };

  const handleStreamClick = (stream) => {
    setSelectedStream(stream);
  };

  const renderLoadingStreams = () => {
    return (
      <div className={styles.loadingContent}>
        <span>{localizedCommonLoading.streams}...</span>
      </div>
    );
  };

  const renderStreams = () => {
    return (
      <ul className={styles.streamOuterContainer}>
        {_.map(streams, (stream, index) => {
          const banner = {
            ..._.get(stream, "banner", {
              mediaType: "image",
              background: {
                thumbnail: StreamDefaultIcon,
                full: StreamDefaultIcon,
              },
            }),
            filter: null,
          };

          return (
            <div
              key={index}
              onMouseEnter={() => setHoveredStream(stream)}
              onMouseLeave={() => setHoveredStream("")}
              onClick={() => handleStreamClick(stream)}
              className={styles.streamContainer}
            >
              <div className={styles.imageContainer}>
                <div
                  className={cx(styles.icon, {
                    [styles.activeStream]:
                      _.isEqual(stream, selectedStream) ||
                      _.isEqual(stream, hoveredStream),
                  })}
                >
                  <Banner
                    applyGradient={true}
                    isActive={
                      _.isEqual(stream, selectedStream) ||
                      _.isEqual(stream, hoveredStream)
                    }
                    value={banner}
                    default={StreamDefaultIcon}
                  />
                    <div className={styles.name}>
                      <Text className={styles.truncatedName} lines={1} text={stream.name} tooltip={{ placement: "auto" }} />
                    </div>
                </div>
              </div>
              <div
                className={styles.metadata}
              >{`${stream.assetCount} ${localizedKeywords.assets}`}</div>
            </div>
          );
        })}
      </ul>
    );
  };

  return (
    <div className={styles.content}>
      <div className={cx(styles.heading, styles.headingBorder)}>
        {`${localizedStreamAccess.title} (${_.size(streams)})`}
      </div>
      <div className={styles.streamBodyContainer}>
        <div
          className={styles.streambody}
          onMouseLeave={() => setHoveredStream("")}
        >
          {loadingStreams && renderLoadingStreams()}
          {!loadingStreams && renderStreams()}
        </div>
        <div className={styles.seperator} />
        <div className={styles.editView}>
          <ManageUserAccess
            stream={_.size(selectedStream) > 0 ? selectedStream : {}}
          />
        </div>
      </div>
    </div>
  );
}

export default StreamAccessManagementView;
